var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,on:{"click":_vm.onClick}},[_c('span',{staticClass:"open"},[_vm._v(_vm._s(_vm.openName))]),_vm._v(" "),_c('span',{staticClass:"close"},[_vm._v(_vm._s(_vm.closeName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }